import { Box, Checkbox, IconButton, Stack, TableCell, TableRow } from '@mui/material'
import React from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';


const ReadOnlyRow = ({ row, setEditRowId, setDeleteRow, setOpenNuevoProveedor, setOldRow}) => {

    const handleDeleteClick = (event, row) => {
        event.preventDefault();
        setEditRowId(null);
        setDeleteRow(row);
    }
    
    const handleEditClick = (event, row) => {
        event.preventDefault();
        //console.log('handelEditClick row: ', row);
        setOldRow(row);
        setEditRowId(row.id);
        setOpenNuevoProveedor(true);    //Abre el dialogo para nuevo/editar proveedor
    }

    return (
        <TableRow key={row.id} style={{textDecoration: row.enF? 'none' : 'line-through'}}>
            <TableCell key={row.id + '_id'} align='left'>{row.id}</TableCell>
            <TableCell key={row.id + '_en'} align='left'><Checkbox disabled checked={row.enF ? true : false} /></TableCell>
            <TableCell key={row.id + '_prov'} align='left'>
                <Box sx={{width: '140px'}}>
                    {row.proveedor}
                </Box>
            </TableCell>    
            <TableCell key={row.id + '_nomc'} align='left'>{row.nombreContacto}</TableCell>
            <TableCell key={row.id + '_telc'} align='right'>
                <Box sx={{width: '100px'}}>
                    {row.telfContacto}
                </Box>
            </TableCell>
            <TableCell key={row.id + '_dvis'} align='left'>{row.diasVisita}</TableCell>
            <TableCell key={'controles_' + row.id} align='left'>
                <Stack direction='row' spacing={0}>
                    <IconButton color="primary" aria-label="edit" onClick={(event) => handleEditClick(event, row)}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton sx={{ color: 'red' }} aria-label="edit" onClick={(event) => handleDeleteClick(event, row)}>
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </TableCell>
        </TableRow>
    )
}

export default ReadOnlyRow